import React from 'react';
import { useTour } from 'hooks/useTour';

import { Container } from './styles';

const TourOverlay: React.FC = () => {
  const { showTour } = useTour();
  return showTour && <Container />;
};

export default TourOverlay;
